import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from 'antd';
import CustomModal from '../../components/common/CustomModal';
import { toast } from 'react-toastify';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import methodModel from '../../methods/methods';
import Layout from '../../components/global/layout';
import FormControl from '../../components/common/FormControl';
import shared from './shared';
import { Routes } from '../../methods/ApiRoutes';
import MultiSelectDropdown from '../../components/common/MultiSelectDropdown';
import { CgArrowLeft } from 'react-icons/cg';
import { useSelector } from 'react-redux';
import { FiChevronDown, FiChevronUp, FiHelpCircle } from 'react-icons/fi';
import environment from '../../environment';

function AddEditNotification() {
  const { id } = useParams();
  const user = useSelector(state => state.user);

  const [form, setform] = useState({
    title: '',
    message: '',
    venueIds: [],
    customerIds: [],
  });

  const [venueList, setVenueList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const history = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);

  const formValidation = [
    { key: 'title', required: true },
    { key: 'message', required: true },
  ];
  const formatEmail = (email = '') => {
    const [username, domain] = email.split('@');
    return `${username}@${domain?.toLowerCase()}`;
  };

  // Fetch venues list once and load details (if editing)
  useEffect(() => {
    loader(true);
    ApiClient.get(Routes.Venue.listApi, { status: 'active', page: 1, count: 2000 }).then(res => {
      if (res.success) {
        const venues = res?.data?.map(item => ({
          ...item,
          id: item?._id || item?.id,
          name: (item?.name || item?.venueName || '')
            .toLowerCase()
            .replace(/\b\w/g, char => char.toUpperCase())
        })) || [];
        setVenueList(venues);

        if (id) {
          ApiClient.get(shared.detailApi, { id }).then(detailRes => {
            if (detailRes.success) {
              const data = detailRes?.data;
              const savedVenueIds = (data?.venueIds || [])?.map(v => v?._id || v?.id || v);

              setform({
                id: data?._id || data?.id,
                title: data?.title || data?.type || '',
                message: data?.message || data?.discription || '',
                venueIds: savedVenueIds,
                customerIds: (data?.customerIds || data?.to || [])?.map(c => c?._id || c?.id || c),
              });

              fetchCustomersByVenues(savedVenueIds, true, venues);
            }
            loader(false);
          });
        } else {
          // Add mode: fetch all customers initially since no venue is selected
          fetchCustomersByVenues([], false, venues);
          loader(false);
        }
      } else {
        loader(false);
      }
    });
  }, [id]);

  // Re-fetch customers whenever venueIds selection changes
  const fetchCustomersByVenues = (selectedVenueIds, isInitialLoad = false, currentVenueList = null) => {
    const activeVenues = currentVenueList || venueList;

    setCustomerLoading(true);

    if (!selectedVenueIds?.length) {
      // Fetch all customers in the system since no venue is selected
      const params = {
        status: 'active',
        role: environment.userRole,
        page: 1,
        count: 2000,
      };
      ApiClient.get(Routes.User.listApi, params).then(res => {
        if (res.success) {
          const fetchedCustomers = res?.data
            ?.filter((_itm) => _itm?.email)
            ?.map(item => ({
              id: item?._id || item?.id,
              name: `${(
                item?.fullName ||
                item?.name ||
                item?.firstName ||
                ''
              )
                .toLowerCase()
                .replace(/\b\w/g, char => char.toUpperCase())} -(${item?.email})`
            })) || [];

          setCustomerList(fetchedCustomers);
        }
        setCustomerLoading(false);
      }).catch(() => {
        setCustomerLoading(false);
      });
      return;
    }

    const params = {
      status: 'active',
      role: environment.userRole,
      page: 1,
      count: 2000,
      venueIds: selectedVenueIds?.map(v => v?._id || v?.id || v)?.join(','),
    };
    console.log(params, "params")
    ApiClient.get('venue/customers', params, '', false).then(res => {
      if (res.success) {
        const fetchedCustomers = res?.data
          ?.filter((_itm) => _itm?.userDetail?.email)
          ?.map(item => ({
            id: item?.userDetail?._id || item?.userDetail?.id,
            name: `${(
              item?.userDetail?.fullName ||
              item?.userDetail?.name ||
              item?.userDetail?.firstName ||
              ''
            )
              .toLowerCase()
              .replace(/\b\w/g, char => char.toUpperCase())} -(${item?.userDetail?.email})`
          })) || [];

        setCustomerList(fetchedCustomers);

        // Select all fetched customers by default
        if (!isInitialLoad) {
          setform(prev => ({
            ...prev,
            customerIds: fetchedCustomers.map(item => item.id)
          }));
        }
      }
      setCustomerLoading(false);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    const invalid = methodModel.getFormError(formValidation, form);
    if (invalid) return;

    let method = 'post';
    let url = shared.addApi;

    const value = {
      title: form.title,
      message: form.message,
      venueIds: form.venueIds,
      customerIds: form.customerIds,
    };

    if (id) {
      method = 'put';
      url = shared.editApi;
      value.id = form.id || id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then(res => {
      if (res.success) {
        history(`/${shared.url}`);
      }
      loader(false);
    });
  };

  useEffect(() => {
    console.log("Selected Venues:", form.venueIds);
    console.log("Customer List:", customerList);
  }, [form.venueIds, customerList]);

  return (
    <Layout>
      <form onSubmit={handleSubmit}>
        <div className="pprofile1">
          <div className="flex justify-between items-center mb-8 flex-wrap gap-3">
            <div className="flex items-center">
              <Tooltip placement="top" title="Back">
                <Link
                  to={`/${shared.url}`}
                  className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all bg-white mr-3"
                >
                  <CgArrowLeft />
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">
                  {form?.id ? 'Edit' : 'Add'}
                  {' '}
                  {shared.addTitle}
                </h3>
              </div>
            </div>

            <button
              type="submit"
              className="text-white bg-[#CC9900] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-6 py-2 h-10 text-center"
            >
              {form?.id ? 'Update' : 'Save'}
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {/* Title */}
            <div className="mb-3">
              <FormControl
                type="text"
                name="title"
                label="Title"
                placeholder="Enter Title here"
                value={form?.title}
                onChange={(e) => setform({ ...form, title: e })}
                required
              />
              {submitted && !form.title && (
                <div className="d-block text-red-600">Title is required</div>
              )}
            </div>

            {/* Venue IDs */}
            <div className="mb-3">
              <label className="text-sm mb-2 block text-[#2D2D2D]">
                Select Venues
              </label>
              <MultiSelectDropdown
                id="venueDropdown"
                isSingle={false}
                displayValue="name"
                theme="search"
                placeholder="All Venues"
                isClearable={false}
                intialValue={form?.venueIds || []}
                result={(e) => {
                  const selected = e?.value || [];
                  // Reset customers when venue selection changes
                  setform(prev => ({ ...prev, venueIds: selected, customerIds: [] }));
                  fetchCustomersByVenues(selected);
                }}
                options={venueList}
              />
            </div>

            {/* Customer IDs */}
            <div className="mb-3">
              <label className="text-sm mb-2 block text-[#2D2D2D]">
                Select Customers
                <span className="ml-2 text-xs text-[#CC9900] font-normal">
                  {form?.venueIds?.length > 0 ? `(filtered by ${form.venueIds.length} venue${form.venueIds.length > 1 ? 's' : ''})` :
                    '(All customers)'}
                </span>
              </label>
              {customerLoading ? (
                <div className="border border-gray-200 rounded-lg h-10 flex items-center px-3 text-sm text-gray-400 gap-2">
                  <svg className="animate-spin h-4 w-4 text-[#CC9900]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                  </svg>
                  Loading customers...
                </div>
              ) : (
                <MultiSelectDropdown
                  id="customerDropdown"
                  isSingle={false}
                  displayValue="name"
                  theme="search"
                  placeholder={customerList.length ? `${customerList.length} customers available` : 'No customers found'}
                  isClearable={false}
                  intialValue={form?.customerIds || []}
                  result={(e) => {
                    setform(prev => ({ ...prev, customerIds: e?.value }));
                  }}
                  options={customerList}
                />
              )}
            </div>

            {/* Message */}
            <div className="mb-3 lg:col-span-2">
              <FormControl
                type="textarea"
                name="message"
                label="Message"
                placeholder="Enter message here"
                value={form?.message}
                onChange={(e) => setform({ ...form, message: e })}
                required
              />
              {submitted && !form.message && (
                <div className="d-block text-red-600">Message is required</div>
              )}
            </div>


          </div>


        </div>
      </form>

      {/* Help Modal */}
      <CustomModal
        open={isHelpModalVisible}
        onClose={() => setIsHelpModalVisible(false)}
        width={650}
      >
        <div className="flex flex-col font-sans">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#CC9900] via-[#E6B800] to-[#CC9900] p-6 text-white relative">
            <div className="flex justify-between items-start gap-4">
              <div>
                <h3 className="text-xl font-bold leading-snug">
                  💡 How It Works: Audience Targeting Guide
                </h3>
                <p className="text-sm text-white/90 mt-1">
                  Learn how target lists dynamically adjust based on venue filter selection
                </p>
              </div>
            </div>
          </div>

          {/* Ticket Dotted Separator */}
          <div className="relative bg-gray-50" style={{ height: '28px' }}>
            <svg className="absolute left-0 top-0 h-full" style={{ width: '14px' }} viewBox="0 0 14 28" preserveAspectRatio="none">
              <path d="M0,0 C14,0 14,28 0,28 Z" fill="white" />
            </svg>
            <div className="absolute" style={{ top: '50%', left: '14px', right: '14px', transform: 'translateY(-50%)', borderTop: '1.5px dashed #d1d5db' }} />
            <svg className="absolute right-0 top-0 h-full" style={{ width: '14px' }} viewBox="0 0 14 28" preserveAspectRatio="none">
              <path d="M14,0 C0,0 0,28 14,28 Z" fill="white" />
            </svg>
          </div>

          {/* Body */}
          <div className="p-6 space-y-6">
            <p className="text-sm text-gray-600 leading-relaxed">
              This notification creation system dynamically adjusts the target audience list depending on your venue selection.
            </p>

            <div className="space-y-4">
              <div className="flex gap-4 p-4 rounded-xl border border-gray-100 bg-gray-50/50">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-orange-50 text-orange-500 font-bold text-sm flex-shrink-0">1</span>
                <div>
                  <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">No Venue Filter</h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    If you leave the Venues selection empty, **all active customers** in the system will be listed. None are checked by default, so you can manually select specific customer(s).
                  </p>
                </div>
              </div>

              <div className="flex gap-4 p-4 rounded-xl border border-gray-100 bg-gray-50/50">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-50 text-yellow-600 font-bold text-sm flex-shrink-0">2</span>
                <div>
                  <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">Venue Filtering</h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    Selecting specific venues instantly filters the customer list so that **only customers associated with the selected venues are visible**.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 p-4 rounded-xl border border-gray-100 bg-gray-50/50">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-green-50 text-green-600 font-bold text-sm flex-shrink-0">3</span>
                <div>
                  <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">Auto-Selection</h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    When venues are selected, all matching customers are **automatically selected by default**. You can still uncheck individual customers to exclude them.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-4 p-4 bg-amber-50 border border-amber-200 rounded-xl text-xs text-amber-800 flex gap-2.5">
              <span className="text-sm">⚠️</span>
              <p className="leading-relaxed">
                <strong>Important:</strong> Push notifications are sent directly to customer phones using registered device tokens. Successful delivery depends on the customer having the mobile app installed and push notification permissions enabled on their device.
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-6 py-4 border-t border-gray-100 flex justify-end">
            <button
              onClick={() => setIsHelpModalVisible(false)}
              className="px-5 py-2 rounded-xl border border-gray-200 text-gray-600 hover:bg-gray-100 transition-all text-xs font-semibold"
            >
              Got it, thanks!
            </button>
          </div>
        </div>
      </CustomModal>

      {/* Floating Help Button */}
      <Tooltip placement="left" title="How It Works">
        <button
          type="button"
          onClick={() => setIsHelpModalVisible(true)}
          className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-12 h-12 rounded-full bg-[#CC9900] text-white shadow-lg hover:bg-[#B38000] hover:scale-110 active:scale-95 transition-all duration-300"
        >
          <FiHelpCircle className="text-2xl" />
        </button>
      </Tooltip>
    </Layout>
  );
}

export default AddEditNotification;
